export class DriverInformationModel {
  "checkoutHour": number;
  "checkoutDate": string;
  "vin": string;
  "advisorDriverName": string;
  "advisorDriverImage": string;
  "advisorDriverNationalId": string;
  "formattedDate": {
    "weekday": string,
    "date": string
  };
}
